import { Card } from 'components/Form/Card';
import Row from 'components/Form/Row';

const cardStyles = `
  small { margin-top: 1rem; font-weight:500; }
`;

const OpenPortsCard = (props: { data: any, title: string, actionButtons: any,icon:any }): JSX.Element => {
  const portData = props.data;
  return (
    <Card heading={props.title} actionButtons={props.actionButtons} styles={cardStyles} icon={props.icon}>
      {portData.openPorts.map((port: any) => (
          <Row key={port} lbl="" val="">
            <span>{port}</span>
          </Row>
        )
      )}
      <br />
      <small style={{fontSize:'14px'}}>
        Unable to establish connections to:<br />
        {portData.failedPorts.join(', ')}
      </small>
    </Card>
  );
}

export default OpenPortsCard;
